import React, { memo, useState } from "react";
import ProductFilterInside from "./ProductFilterInside";

const ProductFilters = memo(() => {
  const [selectedFilters, setSelectedFilters] = useState([]);

  return (
    <div className="filters-wrapper">
      <ProductFilterInside
        title={"מותג"}
        parameterName={"subBrand"}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
      <ProductFilterInside
        title={"כשרות"}
        parameterName={"kosherSupervision[0].supervisionAgency"}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
      <ProductFilterInside
        title={"חלבי / בשרי"}
        parameterName={"kosherSupervision[0].classification"}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
    </div>
  );
});

export default ProductFilters;
